/**
 * Home IA · Radar de cambios recientes (R5 · ADR-R5-04). Modelo read-only del agregador
 * `GET /api/home-ia/recent-changes`. Es un radar de cambios documentales de severidad relevante,
 * NO un buzon de alertas ni notificaciones: solo expone lo que el backend ya recorto por permisos
 * de fuente. Ante 404 (plan sin `change_detection`) la superficie se oculta por completo.
 */

import { ChangeSeverity } from '../../changes/changes.model';

export type RecentChangesStatus = 'ok' | 'empty' | 'error';

/** Un cambio reciente relevante (severidad alta/critica), con deep-link a `/changes`. */
export interface RecentChangeItem {
  id: string;
  documentId: string;
  severity: ChangeSeverity;
  summary: string;
  changedAt: string;
}

export interface RecentChangesResponse {
  featureAvailable: boolean;
  status: RecentChangesStatus;
  items: RecentChangeItem[];
}

/** Parametros opcionales; el backend clampa. */
export interface RecentChangesParams {
  limit?: number;
}

/**
 * Respuesta "feature no disponible": se emite cuando el endpoint responde 404 (plan sin
 * `change_detection`) para ocultar la superficie sin propagar el error.
 */
export const RECENT_CHANGES_FEATURE_OFF: RecentChangesResponse = {
  featureAvailable: false,
  status: 'empty',
  items: [],
};
